/* eslint-disable react/jsx-no-useless-fragment */
import React from "react"
import connect from "./connect"
import {Wrapper, TitleWrapper, RequestTextWrapper} from "./components"

interface searchProviderApiCallProps {
    searchProviderRequestUrl: string
}

export const SearchProviderApiCall = ({searchProviderRequestUrl}: searchProviderApiCallProps) => {
    return (
        <>
            {searchProviderRequestUrl && (
                <Wrapper data-testid="plp-search-provider-request-url">
                    <TitleWrapper> Search provider api call:</TitleWrapper>
                    <RequestTextWrapper>{searchProviderRequestUrl}</RequestTextWrapper>
                </Wrapper>
            )}
        </>
    )
}

export default connect(SearchProviderApiCall)
